<div class="container">

  <div appAccordion>

    <!-- PANEL -->
    <div id="panel1" [expanded]='true' appAccordionElement>

      <div appAccordionElementHeader>
        <div class="btn btn-sm">{{'MY_RESERVATIONS'|translate}}</div>
      </div>

      <app-accordion-element-body>

        <div *ngIf="isLoading" class="card-body">
          <!-- loading spinner -->
          <div class="text-center m-3">
            <app-spinner size="l" dark="true"></app-spinner>
            <p>{{'LOADING'|translate}}</p>
          </div>
        </div>

        <ng-container *ngIf="!isLoading">
          <!-- no data -->
          <div *ngIf="!hasData" class="card-body">
            <div class="alert alert-info">{{'NO_CURRENT_RESERVATIONS'|translate}}</div>
          </div>

          <!-- loop items -->
          <div class="card" *ngFor="let d of data">
            <div class="card-body px-2">
              <div class="row" [class.text-muted]="d.IsCanceld">

                <div class="col-sm-2 col-md-1 d-none d-sm-block">
                  <app-button [icon]="'pencil'" [hideText]="'true'" [text]="'BTN_EDIT'|translate"
                    (click)="onClickEdit(d.Id)"></app-button>
                </div>

                <div class="col-12 col-sm-10 col-md-11">
                  <div class="row">
                    <div class="col-8 col-lg-4" (click)="onClickEdit(d.Id)">
                      <strong>{{d.Occupancy.DateTimeFrom|eventoDayShort}},
                        {{d.Occupancy.DateTimeFrom|eventoDate}}</strong>
                      {{d.Occupancy.DateTimeFrom|eventoTime}} - {{d.Occupancy.DateTimeTo|eventoTime}}
                    </div>

                    <div class="col-4 col-lg-2 text-right">
                      <span [class.text-warning]="d.IsCanceld" [class.text-success]="!d.IsCanceld">{{d.Status}}</span>
                    </div>

                    <div class="col-12 col-lg-6 text-truncate">
                      <a href="#" (click)="onOpenRoomInfo(d.Id, $event)">{{d.Occupancy.Ressource}}</a>
                      {{d.Designation}}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </ng-container>

      </app-accordion-element-body>

    </div>

  </div>
</div>

<!-- Reservation Dialog -->
<app-modal-dialog #editRoomReservationDialog title="{{'EDIT_ROOM_RESERVATION'|translate}}"
  [body]="modalEditRoomReservation" [showPositive]="false" [showCancel]="false" cancelButton="{{'CLOSE'|translate}}"
  size="lg"></app-modal-dialog>
<ng-template #modalEditRoomReservation>
  <app-messages></app-messages>
  <app-create-room-reservation-dialog [params]="createReservationParams" (saved)="onReservationSaved($event)"
    (canceld)="onReservationCanceld($event)"></app-create-room-reservation-dialog>
</ng-template>

<!-- Reservation Dialog -->
<app-modal-dialog #editDeviceReservationDialog title="{{'EDIT_DEVICE_RESERVATION'|translate}}"
  [body]="modalEditDeviceReservation" [showPositive]="false" [showCancel]="false" cancelButton="{{'CLOSE'|translate}}"
  size="lg"></app-modal-dialog>
<ng-template #modalEditDeviceReservation>
  <app-messages></app-messages>
  <app-create-device-reservation-dialog [params]="createReservationParams" (saved)="onReservationSaved($event)"
    (canceld)="onReservationCanceld($event)"></app-create-device-reservation-dialog>
</ng-template>

<!-- Room Info Dialog -->
<app-modal-dialog #roomInfoDialog title="{{'ROOM_INFORMATION'|translate}}" [body]="modalRoomInfo" [showPositive]="false"
  cancelButton="{{'CLOSE'|translate}}"></app-modal-dialog>
<ng-template #modalRoomInfo>
  <app-room-info [roomId]="activeItemId"></app-room-info>
</ng-template>

<!-- Device Info Dialog -->
<app-modal-dialog #deviceInfoDialog title="{{'DEVICE_INFORMATION'|translate}}" [body]="modalDeviceInfo"
  [showPositive]="false" cancelButton="{{'CLOSE'|translate}}"></app-modal-dialog>
<ng-template #modalDeviceInfo>
  <app-device-info [deviceId]="activeItemId"></app-device-info>
</ng-template>

<!-- Confirmation Dialog -->
<app-modal-dialog #confirmReservationDialog title="{{'RESERVATION_CREATED'|translate}}" [body]="modalConfirmReservation"
  [showPositive]="false" [showCancel]="true" (cancel)="onCloseConfirmation($event)" cancelButton="{{'CLOSE'|translate}}"
  size="lg"></app-modal-dialog>
<ng-template #modalConfirmReservation>
  <app-messages></app-messages>
  <app-confirm-reservation-dialog [idReservation]="confirmReservationId"></app-confirm-reservation-dialog>
</ng-template>